export const useCourseFilters = () => {

  const config = useRuntimeConfig()
  const ageRange = (ageFilter) => {
    const range = ageFilter[0].split('-');
    let min = parseInt(range[0]), max = parseInt(range[1]);
    
    ageFilter.forEach((element) => {
      const r = element.split('-');      
      if (parseInt(r[0]) < min) {
        min = parseInt(r[0]);
      }
      if (parseInt(r[1]) > max) {
        max = parseInt(r[1]);
      }
    })

    return {
      min: min,
      max: max
    }
  }

  const ageSortOrder = (a, b) => {
    const rangeA = a.split('-');
    const rangeB = b.split('-');
    const minA = parseInt(rangeA[0]), minB = parseInt(rangeB[0]);
    return minA - minB;
  }

  const buildAgeFilter = (ageFilter) => {
    if (ageFilter !== null && ageFilter.enable) {
      const options = [{
        name: 'All',
        checked: true,
        id: 'all'
      }];
      ageFilter.ages.sort(ageSortOrder).forEach((element, index) => {
        options.push({
          name: element,
          checked: false,
          id: index
        })
      });
      
      const filter = {
        filterName: ageFilter.name,
        id: 'ages',
        options: options,
        sortOrder: ageFilter.sortOrder
      }
  
      return filter;    
    }
  
    return null;
  }



  const getGenres = async () => {        
    const url = `/api/genres`;

    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch(url, {
        method: 'GET',
        baseURL: config.public.nuxtAPIUrl,      
        transform: ((response) => {
          const data = response.data.map((element) => {
            return {
              id: element.id,        
              ...element.attributes       
            }
          })      
          return data;
        })
      });
    }

    return await useFetch(url, {
      method: 'GET',
      transform: ((response) => {
        const data = response.data.map((element) => {
          return {
            id: element.id,        
            ...element.attributes       
          }
        })      
        return data;
      })
    });
    
    
  }

  const genresList = [
    {
      typeID: 295000,
      typeString: "Coding",
      sortOrder: 1
    },
    {
      typeID: 295002,
      typeString: "Game Dev",
      sortOrder: 2,
    },
    {
      typeID: 295001,
      typeString: "Robotics",
      sortOrder: 3
    },
    {
      typeID: 295003,
      typeString: "Creative",
      sortOrder: 4
    },
    {
      typeID: 295006,
      typeString: "Math",
      sortOrder: 5
    },
    {
      typeID: 295008,
      typeString: "Business",
      sortOrder: 8
    }
  ];

  const getGenreById = (id) => {
    return genresList.find(el => el.typeID == id)
  }

  const validateInterestSelection = (interests, selection) => { 
    const result = selection.filter((value) => interests.find(el => getGenreById(el).typeString == value))
    return result;
  }

  const validateAgeSelection = (ages, selection) => {    
    const result = selection.filter((value) => ages.find(age => age == value))
    return result;
  }

  const buildInterestFilter = (interestFilter) => {

    if (interestFilter !== null && interestFilter.enable) {
      // Create a map to quickly access the sortOrder values
      const sortOrderMap = new Map(genresList.map((genre) => [genre.typeID, genre.sortOrder]));

      const options = [{
        name: 'All',
        checked: true,
        id: 'all'
      }];

      // Convert keys in interestFilter.interests to numbers and sort based on sortOrder
      interestFilter.interests = interestFilter.interests.map((element) => Number(element));
      interestFilter.interests.sort((a, b) => sortOrderMap.get(a) - sortOrderMap.get(b));

      interestFilter.interests.forEach((element) => {
        const name = genresList.find(el => el.typeID == element).typeString;
        options.push({
          name: name,
          checked: false,
          id: element
        })
      });
      
      const filter = {
        filterName: interestFilter.name,
        id: 'interests',
        options: options,
        sortOrder: interestFilter.sortOrder
      }
  
      return filter;    
    }
  
    return null;
  }

  const divisions = [
    {
      id: 22,
      name: "iD Teen Academies"
    },
    {
      id: 25,
      name: "iD Tech Camps"
    },
    {
      id: 41,
      name: "Private Lessons"
    },
    {
      id: 42,
      name: "Virtual Camps"
    },
    {
      id: 44,
      name: "Teen Academies"
    },      
  ];

  const buildProgramsFilter = (programsFilter) => {
    if (programsFilter !== null && programsFilter.enable) {
      const options = [{
        name: 'All',
        checked: true,
        id: 'all'
      }];
  
      const sortedPrograms = programsFilter.programs.slice(); // Create a copy of the array
  
      // Custom sorting to ensure that "iD Tech Camps" (ID 25) comes before "iD Teen Academies" (ID 22)
      sortedPrograms.sort((a, b) => {
        if (a === '25' && b === '22') {
          return -1; // 'iD Tech Camps' (ID 25) comes before 'iD Teen Academies' (ID 22)
        } else if (a === '22' && b === '25') {
          return 1; // 'iD Teen Academies' (ID 22) comes after 'iD Tech Camps' (ID 25)
        }
        return 0; // Keep the existing order for other items
      });
  
      sortedPrograms.forEach((element) => {
        const name = divisions.find(el => el.id == element).name;
        options.push({
          name: name,
          checked: false,
          id: element
        });
      });
  
      const filter = {
        filterName: programsFilter.name,
        id: 'programs',
        options: options,
        sortOrder: programsFilter.sortOrder
      };  
      return filter;
    }
  
    return null;
  };
  
  
  const buildOnlineProgramsFilter = (programsFilter) => {
    const divisions = [      
      {
        id: 41,
        name: "Private Lessons"
      },
      {
        id: 42,
        name: "Virtual Camps"
      },
      {
        id: 44,
        name: "Teen Academies"
      },      
    ];
    if (programsFilter !== null && programsFilter.enable) {
      const options = [{
        name: 'All',
        checked: true,
        id: 'all'
      }];
      programsFilter.programs.forEach((element) => {
        const name = divisions.find(el => el.id == element).name;
        options.push({
          name: name,
          checked: false,
          id: element
        })
      });
      
      const filter = {
        filterName: programsFilter.name,
        id: 'programs',
        options: options,
        sortOrder: programsFilter.sortOrder
      }
  
      return filter;    
    }
  
    return null;
  }

  const buildSkillLevelFilter = (skillFilter) => {
    const skillLevels = [
      {
        id: 51,
        name: "Beginner"
      },
      {
        id: 52,
        name: "Intermediate"
      },
      {
        id: 53,
        name: "Advanced"
      }
    ];
    if (skillFilter !== null && skillFilter.enable) {
      const options = [{
        name: 'All',
        checked: true,
        id: 'all'
      }];
      skillFilter.skillLevels.forEach((element) => {
        const name = skillLevels.find(el => el.id == element).name;
        options.push({
          name: name,
          checked: false,
          id: element
        })
      });
      
      const filter = {
        filterName: skillFilter.name,
        id: 'skillLevel',
        options: options,
        sortOrder: 5
      }
  
      return filter;    
    }
  
    return null;
  }

  const validateSelection = (filters, selection, courseType, savedSelection) => {    
    const result = {
      courseType: courseType,
      location: courseType === 'on-campus' ? savedSelection.location : '',
      ages: ['All'],
      interests: ['All'],
      programs: [],
      skillLevel: ['All']
    };

    if (filters) {
      if (filters.interestsFilter !== null) {
        result.interests = validateInterestSelection(filters.interestsFilter.interests, selection.interests);
      }
  
      if (filters.ageFilter !== null) {
        result.ages = validateAgeSelection(filters.ageFilter.ages, selection.ages);
      }
  
      // For ages and intersts we will carry over any previous selection      
      if (!selection.interests.includes('All')) {
        const matches = result.interests.includes('All') ? selection.interests : selection.interests.filter(interest => result.interests.includes(interest))
        result.interests = matches;
      }
      else {
        result.interests = ['All']
      }      

      if (!selection.ages.includes('All')) {
        const matches = result.ages.includes('All') ? selection.ages : selection.ages.filter(age => result.ages.includes(age))
        result.ages = matches;
      }
      else {
        result.ages = ['All']
      }
  
      // For the programs filter we will remember the previous selection because in this case the division are totally different between experiences
      if (savedSelection.programs.length > 1 || (savedSelection.programs.length == 1 && savedSelection.programs[0] !== 'All')) {
        const newOptions = savedSelection.programs.filter(saved => !result.programs.includes(saved));
        if (newOptions.length > 0) {
          result.programs = newOptions;
        }
        else {
          result.programs = ['All']
        }      
      }
    }

    
    
    if (result.ages.length == 0) {
      result.ages = ['All'];
    }

    if (result.interests.length == 0) {
      result.interests = ['All'];
    }

    if (result.programs.length == 0) {
      result.programs = ['All'];
    }
    
    return result;
  }

  const extractGenres = (urlParam) => {
    const genres = urlParam.split(',');
    const result = []
    genres.forEach((genre) => {     
      const genreId = parseInt(genre);
      if (genreId > 0) {
        const name = getGenreById(genreId).typeString;
        result.push(name);
      }
    })

    return result;
  }

  const extractPrograms = (urlParam) => { 
    const programs = urlParam.split(',');
    const result = []

    programs.forEach((program) => {      
      if (program === 'twoWeek') {        
        result.push('Teen Academies');
      }
      else if (program === 'weekLong') {        
        result.push('Tech Camps');
      }
      else if (program === 'private') {        
        result.push('Private Lessons');
      }
    })

    if (result.length == 0) {
      result.push('All');
    }

    return result;
  }

  const extractLearningStyles = (urlParam) => { 
    const ls = urlParam.split(',');
    const result = []
    
    if (ls.length > 1) {
      result.push('All');
    }
    else {
      ls.forEach((style) => {      
        if (parseInt(style) === 405000) {        
          result.push('On-Campus');
        }
        else if (parseInt(style) === 405001 || parseInt(style) === 405003) {        
          result.push('Online');
        }
      })
    }

    return result;
  }

  return {
    ageRange,
    buildAgeFilter,
    getGenres,
    buildInterestFilter,
    buildProgramsFilter,
    buildSkillLevelFilter,
    buildOnlineProgramsFilter,
    validateInterestSelection,
    validateAgeSelection,
    validateSelection,
    extractGenres,
    extractPrograms,
    extractLearningStyles
  }
}